module.exports = "/_next/static/images/soccerWhite@3x-f2b34e6e76d06d2b4ae64a42beaa7c51.png";